import React, { useEffect, useState } from "react";
import { Global } from "../helpers/Global";

export const FinalizarJornadaManualAdmin = () => {
  const [jornadas, setJornadas] = useState([]);
  const [usuarios, setUsuarios] = useState([]);
  const [mensaje, setMensaje] = useState("");
  const [formData, setFormData] = useState({});

  useEffect(() => {
    fetchJornadas();
    fetchUsuarios();
  }, []);

  const fetchJornadas = async () => {
    try {
      const res = await fetch(Global.url + "jornadas/proceso", {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      });

      if (res.ok) {
        const data = await res.json();
        setJornadas(data);
      } else {
        setMensaje("No se pudieron obtener las jornadas en proceso.");
      }
    } catch (error) {
      console.error("Error al cargar las jornadas:", error);
      setMensaje("Error de conexión con el servidor.");
    }
  };

  const fetchUsuarios = async () => {
    try {
      const res = await fetch(Global.url + "usuarios", {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      });
      if (res.ok) {
        const data = await res.json();
        setUsuarios(data);
      }
    } catch (error) {
      console.error("Error al cargar usuarios:", error);
    }
  };

  const getNombreCompleto = (usuario_id) => {
    const u = usuarios.find((u) => u.id === usuario_id);
    return u ? `${u.nombre} ${u.apellidos || ""}` : "-";
  };

  const handleChange = (jornadaId, campo, valor) => {
    setFormData((prev) => ({
      ...prev,
      [jornadaId]: {
        ...prev[jornadaId],
        [campo]: valor,
      },
    }));
  };

  const finalizarJornada = async (jornadaId) => {
    const datos = formData[jornadaId];
    if (!datos?.fecha_fin || !datos?.comentario) {
      alert("Debes rellenar la fecha de fin y el comentario.");
      return;
    }

    try {
      const res = await fetch(Global.url + "jornadas/finalizar-manualmente", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        body: JSON.stringify({
          id: jornadaId,
          fin: datos.fecha_fin,
          observaciones_admin: datos.comentario,
        }),
      });

      const result = await res.json();
      if (res.ok) {
        alert("Jornada finalizada correctamente.");
        fetchJornadas();
      } else {
        alert(result.message || "Error al finalizar la jornada.");
      }
    } catch (error) {
      console.error("Error al finalizar:", error);
      alert("Error de conexión.");
    }
  };

  return (
    <div className="consulta-ticajes">
      <h2 className="centrar-titulo">Finalizar Jornadas en Proceso </h2>
      {mensaje && <p className="rojo">{mensaje}</p>}

      {jornadas.length === 0 ? (
        <p>No hay jornadas activas actualmente.</p>
      ) : (
        <table className="table-listado">
          <thead>
            <tr>
              <th>Usuario</th>
              <th>Centro</th>
              <th>Inicio</th>
              <th>Gerente</th>
              <th>Fecha Fin</th>
              <th>Motivo</th>
              <th>Acción</th>
            </tr>
          </thead>
          <tbody>
            {jornadas.map((j) => (
              <tr key={j.id}>
                <td>{getNombreCompleto(j.usuario_id)}</td>
                <td>{j.centro}</td>
                <td>{new Date(j.fecha_inicio).toLocaleString()}</td>
                <td>{getNombreCompleto(j.gerente_id) || "Sin gerente"}</td>
                <td>
                  <input
                    type="datetime-local"
                    value={formData[j.id]?.fecha_fin || ""}
                    onChange={(e) => handleChange(j.id, "fecha_fin", e.target.value)}
                  />
                </td>
                <td>
                  <input
                    type="text"
                    placeholder="Motivo del cierre"
                    value={formData[j.id]?.comentario || ""}
                    onChange={(e) => handleChange(j.id, "comentario", e.target.value)}
                  />
                </td>
                <td>
                  <button
                    onClick={() => finalizarJornada(j.id)}
                    disabled={!formData[j.id]?.fecha_fin || !formData[j.id]?.comentario}
                  >
                    Finalizar
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
};
